<template>
<div>
  <a-modal :visible="showModel" title="选择导出时间范围" @ok="handleSubmit" @cancel="close">
    <a-form layout="inline">
      <a-form-item label="筛选时间" >
        <a-range-picker style="width:100%" v-model="chooseDate" format="YYYY-MM-DD"
                        :placeholder="['开始时间', '结束时间']" @change="onDateChange"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</div>
</template>

<script >
export default {
  data(){
    return {
      showModel:false,
      chooseDate:[],
      setupTimeDiff:180 * 24 * 60 * 60 * 1000,
      exportFn:'',
      name:'',
      type:'',
      dateString:[]
    }
  },
  methods:{
    show(e,n,t){
      this.exportFn = e
      this.name = n
      this.type = t
      this.showModel = true
    },
    onDateChange(value, dateString){
      if(dateString){
        this.dateString = dateString
      }
      if(this.chooseDate.length == 2){
        let timeDiff = new Date(this.chooseDate[1]).getTime() - new Date(this.chooseDate[0]).getTime()
        console.log('this.chooseDate,timeDiff,this.setupTimeDiff',this.chooseDate,timeDiff,this.setupTimeDiff)

        if(timeDiff > this.setupTimeDiff){
          this.$message.warning('请选择180天范围内数据')
        }else{
          return true
        }
      }
    },
    handleSubmit(){
      if(this.onDateChange()){
        this.exportFn({
          name:this.name,
          type:this.type,
          date:this.dateString
        })
        const that = this
        setTimeout(()=>{
          that.showModel = false
        },10)
      }
    },
    close(){
      this.showModel = false
    }

  }
}
</script>

<style scoped>

</style>